import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { SupplyChain, PaginatedResponse, SupplyChainUser } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

class UsersAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  retrieve = async (scGuid: string, userGuid: string, config: CustomAxiosConfig = {}): Promise<SupplyChainUser> => {
    const response = await this.api.get(`/accounts/supply_chains/${scGuid}/users/${userGuid}`, config)
    return rawTransform(SupplyChainUser)(response.data)
  }

  list = async (guid: string, config: CustomAxiosConfig = {}): Promise<PaginatedResponse<SupplyChainUser>> => {
    const response = await this.api.get(`/accounts/supply_chains/${guid}/users`, config)
    return paginatedTransform(SupplyChainUser)(response.data)
  }

  create = async (guid: string, data: any = {}, config: CustomAxiosConfig = {}): Promise<SupplyChainUser> => {
    const response = await this.api.post(`/accounts/supply_chains/${guid}/users`, data, config)
    return rawTransform(SupplyChainUser)(response.data)
  }

  patch = async (
    clientGuid: string,
    guid: string,
    data: any,
    config: CustomAxiosConfig = {}
  ): Promise<SupplyChainUser> => {
    const response = await this.api.patch(
      `/accounts/supply_chains/${clientGuid}/users/${guid}`,
      data,
      config
    )
    return rawTransform(SupplyChainUser)(response.data)
  }
}

export class SupplyChainAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<SupplyChain> => {
    const response = await this.api.get(`/accounts/supply_chains/${guid}`, config)
    return rawTransform(SupplyChain)(response.data)
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<SupplyChain>> => {
    const response = await this.api.get('/accounts/supply_chains', config)
    return paginatedTransform(SupplyChain)(response.data)
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<SupplyChain> => {
    const response = await this.api.post('/accounts/supply_chains', data, config)
    return rawTransform(SupplyChain)(response.data)
  }

  patch = async (guid: string, data: any, config: CustomAxiosConfig = {}): Promise<SupplyChain> => {
    const response = await this.api.patch(`/accounts/supply_chains/${guid}`, data, config)
    return rawTransform(SupplyChain)(response.data)
  }

  get users() {
    const api = new UsersAPI(this.api)
    Object.defineProperty(this, 'users', { value: api })
    return api
  }
}
